import { useState } from 'react';
import * as Popover from '@radix-ui/react-popover';
import { HiOutlineQueueList } from "react-icons/hi2";
import { IoMdClose } from "react-icons/io";
import useStore, { useSetThing } from "./context/hooks";
import { FaRegUser } from "react-icons/fa";
import { logout, abbreviateNumber, linkStyles } from "./utils";
import Menu from './Menu';
import classNames from 'classnames';
import { FaBriefcase } from "react-icons/fa6";




export default function MenuButton() {
  const { state, dispatch } = useStore()
  const { user, menuOpen, queue = [] } = state;
  const setThing = useSetThing()
  if (!user) {
    return null
  }
  return (
    <Popover.Root
      open={menuOpen}
    >
      <Popover.Trigger asChild>
        <button
          className={classNames("rounded-full w-[35px] h-[35px] text-2xl inline-flex items-center justify-center hover:bg-violet3 focus:shadow-[0_0_0_2px] focus:shadow-black cursor-default outline-none bottom-4 left-4 fixed ml-5 mb-5")}
          aria-label="Menu"
          onClick={() => setThing('menuOpen', !menuOpen)}
        >
          {/* {user.fire ? <span className='text-xs'>{abbreviateNumber(user.fire)}</span> : <FaRegUser />} */}

          {queue && queue.length > 0 && (
            <div className='px-1 badge bg-yellow-400 text-black absolute top-[-4px] right-[-2px] z-10 text-xs rounded-full'>{queue.length}</div>
          )}
          <FaBriefcase />
          {/* <CiMenuKebab /> */}
          {/* <HiOutlineQueueList /> */}
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className="rounded w-[260px] bg-white shadow-[0_10px_38px_-10px_hsla(206,22%,7%,.35),0_10px_20px_-15px_hsla(206,22%,7%,.2)] will-change-[transform,opacity] data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade z-10"
          sideOffset={5}
        >
          {/* <Menu /> */}
          {/* <Popover.Close
            className="rounded-full h-[25px] w-[25px] inline-flex items-center justify-center text-violet11 absolute top-[5px] right-[5px] hover:bg-violet4 focus:shadow-[0_0_0_2px] focus:shadow-violet7 outline-none cursor-default"
            aria-label="Close"
          >
            <IoMdClose />
          </Popover.Close> */}
          <Popover.Arrow className="fill-yellow-400" />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  )
}